<div
  role="button"
  class="fab fabcontainer d-print-none"
  tabindex="0"
  [attr.aria-label]="'trQuickButtons' | translate"
  [attr.aria-controls]="'quick-access-buttons'"
  [attr.aria-live]="'polite'"
  [attr.aria-atomic]="true"
>
  <div class="mainopShadow floatingicon">
    <div class="mainop d-flex justify-content-center">
      <span class="addicon icon-add_circle-24px2x"></span>
    </div>
  </div>
  <div id="quick-access-buttons" class="fab-inner-icon">
    <button
      id="forms"
      (click)="goToNotification()"
      class="minifab op5 position-relative cursor-pointer d-flex"
      tabindex="0"
    >
      <span
        class="badge bg-danger badge-notification"
        [innerText]="notificationCount"
      ></span>
      <img
        class="m-auto"
        src="assets/Images/Icons/notification_important-24px (1)-W.png"
        alt=""
      />
      <span
        class="common_alert_pos"
        [innerText]="'ShortcutCircleALERTS' | translate"
      >
      </span>
    </button>

    <button
      id="drawings"
      (click)="goToPage('/home?isStatistics=true')"
      class="minifab op4 position-relative cursor-pointer d-flex"
      tabindex="0"
    >
      <img
        class="m-auto"
        src="assets/Images/Icons/leaderboard-24px (1).png"
        alt=""
      />
      <span
        class="common_alert_pos"
        [innerText]="'ShortcutCircleSTATISTICS' | translate"
      ></span>
    </button>

    <button
      [routerLink]="['/services/']"
      id="slides"
      class="minifab op3 position-relative cursor-pointer d-flex"
      style="cursor: pointer"
      tabindex="0"
    >
      <img
        class="m-auto"
        src="assets/Images/Icons/add_circle_outline-24px.png"
        alt=""
      />
      <span
        class="common_alert_pos rquest_con"
        [innerText]="'NewRequest' | translate"
      ></span>
    </button>

    <button
      (click)="goToPage('')"
      id="sheets"
      class="minifab op2 position-relative cursor-pointer d-flex"
      style="cursor: pointer"
      tabindex="0"
    >
      <img class="m-auto" src="assets/Images/Icons/apps-24px@2x.png" alt="" />
      <span
        class="common_alert_pos"
        [innerText]="'ShortcutCircleDASHBOARD' | translate"
      ></span>
    </button>
  </div>
</div>
